import React from "react";
import { Link, useLocation } from "react-router-dom";

import styles from "../styles/TopBar.module.scss";

const TopBar = () => {
  const { pathname } = useLocation();

  // Use useMemo to memoize the navLinks array so it doesn't change on every render
  const navLinks = React.useMemo(
    () => [
      { isActive: pathname === "/", label: "Audio Explorer", value: "/" },
      {
        isActive: pathname === "/voices" || pathname === "/voices-v2",
        label: "Voice Finder",
        value: "/voices",
      },
      {
        isActive: pathname.startsWith("/generate"),
        label: "Audio Generator",
        value: "/generate",
      },
    ],
    [pathname],
  );

  const appNameText = "Text To Speech Portal";

  // Update the document title based on the current route
  React.useEffect(() => {
    const currentRoute = navLinks.find(link => link.isActive);
    if (currentRoute) {
      document.title = `${currentRoute.label} | ${appNameText}`;
    } else {
      document.title = appNameText;
    }
  }, [navLinks, appNameText]);

  return (
    <div className={styles["topbar_container"]}>
      <div className={styles["topbar"]}>
        <div className={styles["logo_container"]}>
          <Link to="/">
            <img
              className={styles["logo"]}
              src={`${process.env.PUBLIC_URL}/images/duolingo-logo.svg`}
            />
          </Link>
          <Link to="/">
            <h3 className={styles["header_text"]}>{appNameText}</h3>
          </Link>
        </div>
        {navLinks.map(link => (
          <div
            className={styles[link.isActive ? "nav_link_active" : "nav_link"]}
            key={link.value}
          >
            <Link reloadDocument={link.isActive} to={link.value}>
              {link.label}
            </Link>
            {link.value === "/voices" ? (
              <Link
                className={styles["nav_link_dogfood"]}
                reloadDocument={link.isActive}
                to="/voices-v2"
              >
                or try v2
              </Link>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBar;
